import { createAppWrap } from '../../create_app_wrap';

const view = '[data-view="yahoo_auth_call_back"]';
const init = () => {
    createAppWrap({
        el: view,
        methods: {
            /**
             * クリックでウインドウを閉じる
             */
            closeWindow: function(notification) {
                window.open('about:blank', '_self').close();
                if (notification) {
                    window.opener.postMessage({action: 'yahoo_auth_call_back_close'}, '*');
                }
            },
        }
    });
};

if (document.querySelector(view)) {
    init();
}
